module.exports = __webpack_public_path__ + "static/media/active-bridge-w-strap.ca071f52.png";